import { gql } from '@apollo/client';
import React from 'react';
import SocialTwitterIcon from '@moda/icons/social-twitter-16';
import { TwitterShareLinkFragment } from '../../generated/types/TwitterShareLinkFragment';
import { ShareLink } from './ShareLink';
import { WINDOW_VARIABLES } from './ShareLink';

interface TwitterProps {
  variant: TwitterShareLinkFragment;
}

export const TWITTER_SHARE_LINK_FRAGMENT = gql`
  fragment TwitterShareLinkFragment on Variant {
    descriptionText: description_text
  }
`;

export const twitterShareUrlBase = 'https://twitter.com/share?url=';

const shareOnTwitter = (variant: TwitterShareLinkFragment) => {
  const link = location.origin + location.pathname + '?utm_source=twitter&utm_medium=share';
  const twitterShareLink =
    twitterShareUrlBase +
    encodeURIComponent(link) +
    '&text=' +
    encodeURIComponent(variant.descriptionText);
  window.open(twitterShareLink, '_blank', WINDOW_VARIABLES);
};

export const TwitterShareLink: React.FC<TwitterProps> = ({ variant }) => {
  return (
    <ShareLink
      aria-label="Share with Twitter"
      handleClick={() => shareOnTwitter(variant)}
      data-testid="twitter-share-link"
    >
      <SocialTwitterIcon />
    </ShareLink>
  );
};
